import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { ListHeader, ListArticle } from '../../components/index';
import api from '../../api/index'
import WebpartBase from '@webparts/views/WebpartBase'
import { openPopup } from '@appbase/util/popup-helper'

@Component({
    components: {
        ListHeader,
        ListArticle
    }
})
export default class ListTabWebpart extends WebpartBase {
    //
    // ──────────────────────────────────────────────── I ──────────
    //   :::::: D A T A : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────
    //
    activeBoardId!: number;
    nowPageNumber: number = 1;
    totalCount!: number;
    listArticles?: any = [];

    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: M E T H O D S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //
    TabClick(boardId: number) {
        if (this.activeBoardId != boardId) {
            this.nowPageNumber = 1;
            this.activeBoardId = boardId
            this.getArticles();
        }
    }

    Prev() {
        if (this.nowPageNumber > 1) {
            this.nowPageNumber--;
            this.getArticles();
        }
    }

    Next() {
        if (Math.ceil(this.totalCount / this.option.displayCount!) > this.nowPageNumber) {
            this.nowPageNumber++;
            this.getArticles();
        }
    }

    Refresh() {
        this.nowPageNumber = 1;
        this.getArticles();
    }

    load() {
        if (this.option.tabs != null && this.option.tabs.length > 0)
            this.activeBoardId = this.option.tabs[0].boardId;

        this.getArticles();
    }

    getArticles() {
        api.webPart.getArticles(this.activeBoardId, this.option.displayCount!, this.nowPageNumber, false, false/*this.option.isUseNotice*/).then((res: any) => {
            this.listArticles = res.data;
        }).catch((err: any) => {
        });
    }

    //
    // ────────────────────────────────────────────────────────── I ──────────
    //   :::::: L I F E S T Y L E : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────────
    //
    mounted() {
        this.load();
    }
}
